// Actions
const REQUEST = "intl/REQUEST";
const SUCCESS = "intl/SUCCESS";

// Reducer
const initialState = {
  loading: false,
  locale: "en",
  messages: {}
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST:
      return { ...state, loading: true };
    case SUCCESS:
      return {
        ...state,
        loading: false,
        locale: action.payload.locale,
        isHindiLang: action.payload.isHindiLang,
        messages: action.payload.messages
      };
    default:
      return state;
  }
}

// Action Creators
export const selectLocaleRequest = () => ({ type: REQUEST });

export const selectLocaleSuccess = ({ locale, isHindiLang, messages }) => ({
  type: SUCCESS,
  payload: { locale, messages, isHindiLang }
});

export const selectLocale = locale => dispatch => {
  // If the default locale is selected, default messages are already loaded
  if (locale === initialState.locale) {
    dispatch(selectLocaleSuccess(initialState));
  } else {
    dispatch(selectLocaleRequest());
    // Load messages for requested locale; fall back to default if not found
    return import(`../../locales/messages/${locale}.json`)
      .then(({ default: messages }) =>
        dispatch(selectLocaleSuccess({ locale, messages }))
      )
      .catch(() => dispatch(selectLocaleSuccess(initialState)));
  }
};
